<nz-modal
  [(nzVisible)]="visible"
  [nzTitle]="modalTitle"
  [nzWidth]="900"
  [nzFooter]="modalFooter"
  (nzOnCancel)="close()"
  nzCentered
>
  <ng-template #modalTitle>
    <div class="modal-title">
      <i nz-icon nzType="thunderbolt" nzTheme="twotone"></i>
      <span>Smart Column Builder</span>
      <nz-tag nzColor="processing">Beta</nz-tag>
    </div>
  </ng-template>

  <ng-container *nzModalContent>
    <!-- ETAPA 1: INPUT JSON -->
    <div *ngIf="step === 'input'" class="input-step">
      <!-- Templates Rápidos -->
      <nz-alert
        nzType="success"
        nzMessage="✨ Modo Super Simples"
        [nzDescription]="'builderScreen.smartColumns.hint' | translateTA"
        [nzCloseable]="true"
        nzShowIcon
      ></nz-alert>

      <div class="quick-templates">
        <h4>
          <i nz-icon nzType="rocket"></i>
          Templates Rápidos
        </h4>
        <div class="template-buttons">
          <button
            *ngFor="let template of templates"
            nz-button
            nzType="dashed"
            (click)="applyTemplate(template)"
          >
            <i nz-icon nzType="fire"></i>
            {{ template.name }}
          </button>
        </div>
      </div>

      <nz-divider nzText="ou cole seu JSON"></nz-divider>

      <!-- Configuração do Path -->
      <nz-form-item>
        <nz-form-label>
          <span>Data Path (Array)</span>
          <nz-tag nzColor="success" style="margin-left: 8px;">Opcional - Auto-detecta</nz-tag>
        </nz-form-label>
        <nz-form-control nzExtra="🤖 Deixe vazio para detectar automaticamente! Ou especifique o caminho (ex: 'response.item_list')">
          <input
            nz-input
            [(ngModel)]="dataPathPrefix"
            [placeholder]="'builderScreen.smartColumns.dataPathPlaceholder' | translateTA"
          />
        </nz-form-control>
      </nz-form-item>

      <!-- Área de Input JSON -->
      <nz-form-item>
        <nz-form-label nzRequired>JSON de Exemplo</nz-form-label>
        <nz-form-control>
          <textarea
            nz-input
            [(ngModel)]="jsonInput"
            placeholder="Cole seu JSON aqui... Ex:
{
  &quot;products&quot;: [
    { &quot;id&quot;: 1, &quot;name&quot;: &quot;Produto 1&quot;, &quot;price&quot;: 100 }
  ]
}"
            [nzAutosize]="{ minRows: 10, maxRows: 15 }"
            class="json-textarea"
          ></textarea>
        </nz-form-control>
      </nz-form-item>

      <!-- Mensagem de Erro -->
      <nz-alert
        *ngIf="errorMessage"
        nzType="error"
        [nzMessage]="errorMessage"
        [nzCloseable]="true"
        nzShowIcon
      ></nz-alert>

      <!-- Botão Analisar -->
      <div class="action-buttons">
        <button
          nz-button
          nzType="primary"
          nzSize="large"
          (click)="analyzeJSON()"
          [disabled]="!jsonInput"
          nzBlock
        >
          <i nz-icon nzType="radar-chart"></i>
          Detectar Colunas Automaticamente
        </button>
      </div>
    </div>

    <!-- ETAPA 2: PREVIEW E SELEÇÃO -->
    <div *ngIf="step === 'preview'" class="preview-step">
      <!-- Alert com Path Detectado -->
      <nz-alert
        nzType="success"
        nzMessage="✅ Array Encontrado!"
        [nzCloseable]="false"
        nzShowIcon
      >
        <div *nzAlertDescription>
          <p><strong>{{ detectedColumns.length }} colunas detectadas!</strong></p>
          <p style="margin: 8px 0;">
            <nz-tag nzColor="blue">
              <i nz-icon nzType="node-index"></i>
              Data Path: <code>{{ dataPathPrefix }}</code>
            </nz-tag>
          </p>
          <p style="margin: 0; font-size: 12px; color: rgba(0,0,0,0.65);">
            Selecione as colunas que deseja adicionar. Você pode editar depois no inspetor.
          </p>
        </div>
      </nz-alert>

      <!-- Ações Rápidas -->
      <div class="quick-actions">
        <button nz-button nzSize="small" (click)="toggleAll()">
          <i nz-icon nzType="check-square"></i>
          Selecionar/Desmarcar Todas
        </button>
        <button nz-button nzSize="small" nzType="dashed" (click)="exportConfig()">
          <i nz-icon nzType="download"></i>
          Exportar Configuração
        </button>
      </div>

      <!-- Lista de Colunas Detectadas -->
      <div class="columns-list">
        <nz-card
          *ngFor="let column of detectedColumns"
          [nzSize]="'small'"
          [class.selected]="column.selected"
          (click)="toggleColumn(column)"
          class="column-card"
        >
          <div class="column-card-content">
            <!-- Checkbox -->
            <label nz-checkbox [(ngModel)]="column.selected" (click)="$event.stopPropagation()"></label>

            <!-- Info da Coluna -->
            <div class="column-info">
              <div class="column-header">
                <strong>{{ column.header }}</strong>
                <nz-tag [nzColor]="getTypeColor(column.type)">
                  <i nz-icon [nzType]="getTypeIcon(column.type)"></i>
                  {{ column.type }}
                </nz-tag>
                <nz-tag *ngIf="column.type === 'search' && column.searchProperties" nzColor="magenta" nzSize="small">
                  <i nz-icon nzType="link"></i> {{ column.searchProperties.entityName }}
                </nz-tag>
                <nz-tag *ngIf="column.type === 'dropdown' && column.options" nzColor="cyan" nzSize="small">
                  <i nz-icon nzType="unordered-list"></i> {{ column.options.length }} opções
                </nz-tag>
              </div>
              <div class="column-details">
                <span class="detail-item">
                  <i nz-icon nzType="field-string"></i>
                  Field: <code>{{ column.field }}</code>
                </span>
                <span class="detail-item">
                  <i nz-icon nzType="node-index"></i>
                  Path: <code>{{ column.dataPath }}</code>
                </span>
              </div>
              <div class="column-sample" *ngIf="column.sampleValue !== undefined">
                <span class="sample-label">Valor de exemplo:</span>
                <code class="sample-value">{{ column.sampleValue }}</code>
              </div>
            </div>
          </div>
        </nz-card>
      </div>

      <!-- Resumo -->
      <nz-statistic
        [nzValue]="getSelectedColumnsCount()"
        [nzTitle]="'Colunas Selecionadas'"
        [nzSuffix]="'/ ' + detectedColumns.length"
        class="selection-summary"
      ></nz-statistic>
    </div>
  </ng-container>

  <ng-template #modalFooter>
    <div class="modal-footer">
      <!-- Etapa INPUT -->
      <ng-container *ngIf="step === 'input'">
        <button nz-button nzType="default" (click)="close()">Cancelar</button>
        <button
          nz-button
          nzType="primary"
          (click)="analyzeJSON()"
          [disabled]="!jsonInput"
        >
          <i nz-icon nzType="arrow-right"></i>
          Próximo
        </button>
      </ng-container>

      <!-- Etapa PREVIEW -->
      <ng-container *ngIf="step === 'preview'">
        <button nz-button nzType="default" (click)="goBack()">
          <i nz-icon nzType="arrow-left"></i>
          Voltar
        </button>
        <button
          nz-button
          nzType="primary"
          (click)="confirm()"
          [disabled]="getSelectedColumnsCount() === 0"
        >
          <i nz-icon nzType="check"></i>
          Adicionar {{ getSelectedColumnsCount() }} Colunas
        </button>
      </ng-container>
    </div>
  </ng-template>
</nz-modal>

